<template>
  <modal :title="$t('SCORECARDS.CHOOSE_TYPE')" :close="close" small>
    <template #content>
      <form @submit="submit">
        <div class="px-6 py-2">
          <lf-input
            class="-mb-0"
            name="name"
            value=""
            :placeholder="$t('SCORECARDS.NAME')"
          />
        </div>
        <div class="grid grid-cols-2 gap-6 p-6 select-none">
          <label
            for="manual"
            class="cursor-pointer rounded-sm border px-6 pt-8 pb-12"
          >
            <div class="mb-6 flex items-center justify-between">
              <icon-base :icon="IconStarCircle" height="20" width="20" />
              <input
                id="manual"
                v-model="type"
                name="scorecardType"
                type="radio"
                :value="SCORECARD_TYPE_MANUAL"
                checked
              />
            </div>
            <lf-h3 class="text-lg font-semibold text-gray-700">
              {{ $t("SCORECARDS.SUBMIT_SCORE_TITLE") }}
            </lf-h3>
            <p>
              {{ $t("SCORECARDS.SUBMIT_SCORE_DESCRIPTION") }}
            </p>
          </label>
          <label
            for="builder"
            class="cursor-pointer rounded-sm border px-6 pt-8 pb-12"
          >
            <div class="mb-6 flex items-center justify-between">
              <icon-base
                :icon="IconLogo"
                height="20"
                width="20"
                viewBox="0 0 35 20"
              />
              <input
                id="builder"
                v-model="type"
                name="scorecardType"
                type="radio"
                :value="SCORECARD_TYPE_BUILDER"
              />
            </div>
            <lf-h3 class="text-lg font-semibold text-gray-700">
              {{ $t("SCORECARDS.SCORECARD_BUILDER_TITLE") }}
            </lf-h3>
            <p>
              {{ $t("SCORECARDS.SCORECARD_BUILDER_DESCRIPTION") }}
            </p>
          </label>
        </div>
        <hr class="mb-6" />
        <div class="flex justify-end px-6 pb-6">
          <outline-button class="mr-3" @click="close">
            {{ $t("COMMON.CANCEL") }}
          </outline-button>
          <primary-button type="submit">
            {{ $t("COMMON.CONTINUE") }}
          </primary-button>
        </div>
      </form>
    </template>
  </modal>
</template>
<script setup lang="ts">
import { ref } from "vue";

import { useForm } from "vee-validate";

import {
  SCORECARD_STATUS_DRAFT,
  SCORECARD_TYPE_BUILDER,
  SCORECARD_TYPE_MANUAL,
} from "@/helpers/constants";
import { dispatchAction } from "@/helpers/vee-validate";
import router from "@/router";

import Modal from "../ui/Modal.vue";
import IconLogo from "@/components/icons/IconLogo.vue";
import IconStarCircle from "@/components/icons/IconStarCircle.vue";

import type { IScorecard } from "@/models/scorecards";
import type { PropType } from "vue";

const props = defineProps({
  close: {
    type: Function as PropType<() => void>,
    required: true,
  },
});

const type = ref(SCORECARD_TYPE_MANUAL);

const { handleSubmit } = useForm({
  initialValues: {
    name: "",
  },
});

const submit = handleSubmit(async (values, actions) => {
  const routeName =
    type.value === SCORECARD_TYPE_MANUAL
      ? "ScorecardsTemplate"
      : "ScorecardsBuilder";

  const payload: Partial<IScorecard> = {
    name: values.name,
    type: type.value,
    status: SCORECARD_STATUS_DRAFT,
  };

  try {
    const newScorecard: IScorecard = await dispatchAction(
      payload,
      actions,
      "scorecards/createScorecard"
    );

    if (!newScorecard?.id) {
      return;
    }

    props.close();
    router.push({ name: routeName, params: { id: newScorecard.id } });
  } catch {
    return;
  }
});
</script>
